import request from './common/request'
import qs from 'qs'

import { MERCHANT_EVALUATION_PROJECT_RANK_URI } from './urls'

// 列表
async function list (params) {
  return request(
    {
      url: MERCHANT_EVALUATION_PROJECT_RANK_URI,
      method: 'GET',
      params
    }
  )
}

async function all (params) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_PROJECT_RANK_URI}/all`,
      method: 'GET',
      params
    }
  )
}

// 详情
async function getById (id) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_PROJECT_RANK_URI}/${id}`,
      method: 'GET'
    }
  )
}

// 插入
async function insert (data) {
  return request(
    {
      url: MERCHANT_EVALUATION_PROJECT_RANK_URI,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 更新
async function update (data) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_PROJECT_RANK_URI}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

// 删除
async function remove (id) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_PROJECT_RANK_URI}/${id}`,
      method: 'DELETE'
    }
  )
}

export default {
  list,
  all,
  getById,
  insert,
  update,
  remove
}



// WEBPACK FOOTER //
// ./src/api/merchant-evaluation-project-rank.js